import { UUID } from '../common'
export default {
  install (Vue) {
    Vue.$UUID = UUID
    Object.defineProperties(Vue.prototype, {
      $UUID: { get () { return UUID } }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/uuid/index.js